var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterApplied(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1788 3.71362H5.49329C5.07275 3.71362 4.84007 4.20119 5.10459 4.52812L11.138 11.985C11.21 12.074 11.2493 12.185 11.2493 12.2995V17.7007C11.2493 17.8586 11.3239 18.0073 11.4506 18.1016L13.5843 19.6912C13.9141 19.937 14.383 19.7016 14.383 19.2903V12.3068C14.383 12.1879 14.4254 12.0728 14.5026 11.9824L17.3022 8.69935",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9727 7.33354C19.3534 7.33354 20.4727 6.21425 20.4727 4.83354C20.4727 3.45283 19.3534 2.33354 17.9727 2.33354C16.5919 2.33354 15.4727 3.45283 15.4727 4.83354C15.4727 6.21425 16.5919 7.33354 17.9727 7.33354Z",
    fill: "#1859B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterApplied);
export default __webpack_public_path__ + "static/media/filterApplied.10e0ce0924ceb98da23d49ce0f8d7727.svg";
export { ForwardRef as ReactComponent };